import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "p-4 mb-4 bg-white border shadow-lg dark:border-gray-200 dark:border dark:bg-gray-800 md:flex rounded-3xl border-clay-200" }
const _hoisted_2 = ["href", "alt", "title"]
const _hoisted_3 = ["src", "alt", "title"]
const _hoisted_4 = { class: "justify-between flex-1 ml-4 md:flex md:flex-col" }
const _hoisted_5 = { class: "items-center flex-none mb-2" }
const _hoisted_6 = ["href", "alt", "title"]
const _hoisted_7 = { class: "" }
const _hoisted_8 = { class: "text-sm text-clay-950" }
const _hoisted_9 = { class: "tag-list" }
const _hoisted_10 = ["alt", "title", "href"]
const _hoisted_11 = ["href", "alt", "title"]
const _hoisted_12 = { class: "space-y-2" }
const _hoisted_13 = {
  key: 0,
  class: "block pb-2 my-2 text-xs text-gray-600 md:inline-block"
}
const _hoisted_14 = {
  key: 1,
  class: "block pb-2 my-2 text-xs text-gray-600 md:inline-block"
}
const _hoisted_15 = { class: "justify-between sm:flex" }
const _hoisted_16 = { class: "mt-2 ml-4 shrink-0 md:mt-0" }
const _hoisted_17 = { class: "grid grid-cols-2 mt-4 space-x-1 text-sm text-center sm:text-left sm:mt-0" }

import Bookmarking from "@/main/components/Bookmarking.vue";
import Fanning from "@/main/components/Fanning.vue";

import {MonologueDto} from "@/dtos";


export default /*@__PURE__*/_defineComponent({
  __name: 'MonologueCard',
  props: {
    monologue: {}
  },
  setup(__props: any) {

const props = __props;


const monologue: MonologueDto = props.monologue;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      href: `/${_unref(monologue).urlSlug}`,
      alt: _unref(monologue).showTitle,
      title: _unref(monologue).showTitle,
      class: "shrink-0 guide-img-container"
    }, [
      _createElementVNode("img", {
        class: "object-cover w-20 h-20 mx-auto md:w-32 md:h-32 rounded-3xl",
        src: _unref(monologue).showLogo,
        alt: `${_unref(monologue).showTitle} logo`,
        title: `${_unref(monologue).showTitle} logo`
      }, null, 8, _hoisted_3)
    ], 8, _hoisted_2),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("a", {
          href: `/${_unref(monologue).urlSlug}`,
          alt: _unref(monologue).showTitle,
          title: `${_unref(monologue).showTitle} excerpt`,
          class: "inline-block text-sm font-medium text-clay-950 text-md hover:underline hover:decoration-slate-900 hover:transition-all hover:decoration-2 md:block"
        }, [
          _createElementVNode("h3", _hoisted_7, _toDisplayString(_unref(monologue).getExcerptOrDefault?.substring(0, 30)) + "...", 1)
        ], 8, _hoisted_6),
        _createElementVNode("p", null, [
          _cache[0] || (_cache[0] = _createElementVNode("em", { class: "visible ml-1 text-xs lg:ml-0 lg:invisible" }, "(", -1)),
          _createElementVNode("em", _hoisted_8, [
            _createElementVNode("span", _hoisted_9, [
              _createElementVNode("a", {
                alt: _unref(monologue).characterName,
                title: _unref(monologue).characterName,
                class: "text-sm text-clay-950",
                href: `/${_unref(monologue).characterId}`
              }, _toDisplayString(_unref(monologue).characterName), 9, _hoisted_10)
            ])
          ]),
          _cache[1] || (_cache[1] = _createElementVNode("em", { class: "visible text-xs lg:invisible" }, ")", -1))
        ]),
        _createElementVNode("p", null, [
          _createElementVNode("a", {
            href: `/${_unref(monologue).showId}`,
            alt: _unref(monologue).showTitle,
            title: _unref(monologue).showTitle,
            class: "text-sm text-slate-800"
          }, _toDisplayString(_unref(monologue).showTitle), 9, _hoisted_11)
        ]),
        _createElementVNode("div", _hoisted_12, [
          (_unref(monologue).displaysFullText)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, _cache[2] || (_cache[2] = [
                _createElementVNode("span", { class: "px-2 py-1 mx-1 mb-2 text-xs font-medium rounded-full text-clay-950 bg-clay-50 dark:border" }, " Text ", -1)
              ])))
            : _createCommentVNode("", true),
          (_unref(monologue).hasVideos)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, _cache[3] || (_cache[3] = [
                _createElementVNode("span", { class: "px-2 py-1 mx-1 mb-2 text-xs font-medium rounded-full text-clay-950 bg-clay-50 dark:border" }, " Video ", -1)
              ])))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "mr-4" }, null, -1)),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createVNode(Fanning, {
                id: _unref(monologue).id,
                "number-of-fans": _unref(monologue).fanCount
              }, null, 8, ["id", "number-of-fans"]),
              _createVNode(Bookmarking, {
                id: _unref(monologue).id
              }, null, 8, ["id"])
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})